import ArticleLayout from '@/components/feature/ArticleLayout';
import { cssbuyArticle } from '@/mocks/article-data';
import ArticleSchema from '@/components/feature/ArticleSchema';

export default function CssbuyArticle() {
  return (
    <>
      <ArticleSchema
        slug="cssbuy-spreadsheet-guide"
        title="CSSBuy Spreadsheet Complete Guide 2026"
        description="Complete CSSBuy Spreadsheet guide with navigation tips, community resource overview, safety practices, and comparison with Hipobuy, Kakobuy, Superbuy and Oopbuy platforms. Your trusted CSSBuy Spreadsheet reference."
        imageUrl="https://readdy.ai/api/search-image?query=Organized%20community%20bulletin%20board%20aesthetic%20with%20pinned%20notes%20product%20photos%20and%20handwritten%20recommendations%20on%20corkboard%20surface%2C%20warm%20cozy%20lighting%2C%20collaborative%20knowledge%20sharing%20atmosphere%2C%20cream%20and%20kraft%20paper%20tones%20with%20handwritten%20ink%20accents%2C%20indie%20maker%20space%20vibe%2C%20thoughtful%20curated%20arrangement&width=1920&height=800&seq=article-cssbuy-hero-v2&orientation=landscape"
      />
      <ArticleLayout article={cssbuyArticle} />
    </>
  );
}